export enum RolesWeb {
  RESPONSABLE = 7,
  COMERCIO = 3,
  FINANCIERO = 12
}
